import { LabeledField } from './labeled-field.component';

import { Appointment } from '@/types/appointments.types';
import { AppointmentCardExportGuide } from '@/app/(main)/(pages)/(auth)/agendamentos/_components/card-appointment/card-appointment-export-guide.component';
import { Typography } from '@/components/ui/typography/typography.component';
import { TypographyVariant } from '@/components/ui/typography/typography.type';

interface GuideCodeFieldProps {
  appointment: Appointment;
  showExportGuide?: boolean;
}

export function GuideCodeField({ appointment, showExportGuide = true }: GuideCodeFieldProps) {
  return (
    <LabeledField label="Código da Guia">
      <div className="flex items-center gap-2">
        <Typography variant={TypographyVariant.BODY_TEXT} className="flex-1">
          {appointment.referral}
        </Typography>
        {showExportGuide && <AppointmentCardExportGuide appointment={appointment} />}
      </div>
    </LabeledField>
  );
}
